<template>
  <div class="pa-park-note-detail" v-if="isVisibleNote">
    <div class="pa-title">{{parkNote.title}}</div>
    
    <div class="pa-date">異世界地球時間 {{parkNote.created_at | mutateJPFullWidthDateTime}}</div>

    <div class="pa-meta">
      <div class="character-meta">
        <div class="character-icon">
          <CharacterIcon :character="parkNote.character" />
        </div>
        
        <div class="pa-name">{{parkNote.character.displayname | nameTruncate}}</div>
      </div>
    </div>
    
    <div class="pa-content">
      <div v-html="bodyHtml" ref="contentField"></div>
    </div>
    
    <div class="pa-footer-meta">
      <div class="pa-badges">
        <PAHeartPlusButton :prefixIcon="heartPlusIconPrefixIcon" @click="handleClickHeartPlusButton" />

        <PACommonBadgeBanner @click="handleClickHeartBadgeButton" :count="parkNote.like_count">
          <template slot="icon">
            <font-awesome-icon icon="heart" />
          </template>
        </PACommonBadgeBanner>

        <PACommonBadgeBanner :count="replyCommnetBadgeText">
          <template slot="icon">
            <font-awesome-icon icon="comments" />
          </template>
        </PACommonBadgeBanner>
      </div>

      <div class="pa-controls">
        <button class="button control-button" v-if="parkNote.could_edit" @click.prevent="handleClickNoteEdit">
          <font-awesome-icon icon="edit" />
        </button>
        <button class="button control-button" v-if="parkNote.could_delete" @click.prevent="handleClickNoteTrash">
          <font-awesome-icon icon="trash" />
        </button>
      </div>
    </div>
    
    <div class="pa-comment-view">
      <PAParkNoteCommentViewSet
       :parkNoteId="parkNoteId"
      />
    </div>

    <PAParkNoteLikeBadgeCharacterListModal />
    <PAParkNoteDeleteConfirmModal />
  </div>
</template>

<script>
import CharacterIcon from '@/components/Parts/CharacterIcon/CharacterIcon.vue'
import PACommonBadgeBanner from '@/components/Parts/PACommonBadgeBanner/PACommonBadgeBanner.vue'

import PAHeartPlusButton from '@/components/Parts/PAHeartPlusButton/PAHeartPlusButton.vue'

import PAParkNoteCommentViewSet from '@/components/Pages/Parks/Note/PAParkNoteCommentViewSet/PAParkNoteCommentViewSet.vue'

import PAParkNoteLikeBadgeCharacterListModal from '@/components/Pages/Parks/Note/PAParkNoteLikeBadgeCharacterListModal/PAParkNoteLikeBadgeCharacterListModal.vue'
import PAParkNoteDeleteConfirmModal from '@/components/Pages/Parks/Note/PAParkNoteDeleteConfirmModal/PAParkNoteDeleteConfirmModal.vue'

import {GetParkNote} from '@/graphql/queries/ParkNote.graphql'

import {AddParkNoteLike, RemoveParkNoteLike} from '@/graphql/mutations/ParkNoteLike.graphql'

import Quill from 'quill'

import { Base64 } from 'js-base64'

export default {
  props : {
    parkNoteId : {
      default: null
    }
  },

  components : {
    CharacterIcon,
    PAHeartPlusButton,
    PACommonBadgeBanner,

    PAParkNoteCommentViewSet,

    PAParkNoteLikeBadgeCharacterListModal,
    PAParkNoteDeleteConfirmModal
  },

  data(){
    return {
      bodyHtml  : null,

      heartPlusIconPrefixIcon : 'plus', // minus
      replyCommnetBadgeText   : '0/10'
    };
  },

  apollo : {
    parkNote : {
      query : GetParkNote,
      
      variables(){
        return {
          id : this.parkNoteId
        };
      },

      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    }
  },

  watch : {
    parkNote : {
      handler(data){
        if(typeof data === 'undefined') return;
        
        const parsedDelta = JSON.parse(Base64.decode(data.body));

        this.bodyHtml = this.convertDeitaToHtml(parsedDelta);

        this.replyCommnetBadgeText = data.reply_num+'/10';

        if(data.is_liked === true){
          this.heartPlusIconPrefixIcon = 'minus';
        }else{
          this.heartPlusIconPrefixIcon = 'plus';
        }
      },
      immediate: true,
      deep: true
    },

    bodyHtml : {
      handler(value){
        if(value === null) return;

        this.$nextTick(() => {
          this.initializeImageSwiper();
        });
      },
      immediate: true
    }
  },

  computed : {
    isVisibleNote(){
      if(typeof this.parkNote !== 'undefined'){
        return true;
      }else{
        return false;
      }
    }
  },

  methods : {
    convertDeitaToHtml(deltaObject){
      const htmlData = document.createElement('div');

      (new Quill(htmlData)).setContents( deltaObject );

      return htmlData.getElementsByClassName('ql-editor')[0].innerHTML;
    },

    handleClickNoteEdit(){
      if(this.parkNote.could_edit === false) return;

      this.$store.dispatch({
        type            : 'parkNote/updateIsOpenEditEditorModal',
        value           : true
      });
    },

    handleClickNoteTrash(){
      if(this.parkNote.could_delete === false) return;

      this.$store.dispatch({
        type            : 'parkNoteDeleteModal/updateModal',
        isOpen          : true,
        isFreezModal    : false,
        isSubmitLoading : false,
        behaviour       : 'deleteNote',
        parkNote        : this.parkNote,
        parkNoteComment : null
      });
    },

    handleClickHeartPlusButton(){
      if(this.parkNote.is_liked === true){
        this.executeRemoveParkNoteLike();
      }else{
        this.executeAddParkNoteLike();
      }
    },

    executeAddParkNoteLike(){
      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : AddParkNoteLike,
          variables : {
            parkNoteId  : this.parkNoteId,
            type        : 'heart'
          }
        }).then(async () => {
          this.$apollo.queries.parkNote.refetch();
          
          resolve(true);
        }).catch(async (err) => {
          const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
          this.apolloResultValidation(simpleErrorSet);

          resolve(false);
        });
      });
    },

    executeRemoveParkNoteLike(){
      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : RemoveParkNoteLike,
          variables : {
            parkNoteId  : this.parkNoteId,
            type        : 'heart'
          }
        }).then(async () => {
          this.$apollo.queries.parkNote.refetch();
          
          resolve(true);
        }).catch(async (err) => {
          const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
          this.apolloResultValidation(simpleErrorSet);

          resolve(false);
        });
      });
    },

    handleClickHeartBadgeButton(){
      const newUrlQuery = Object.assign({}, this.$route.query);

      newUrlQuery['love_badge_character_park_note_id'] = this.parkNoteId;
      newUrlQuery['y'] = window.scrollY;

      this.$router.push({
        name    : this.$route.name,
        params  : this.$route.params,
        query   : newUrlQuery
      });
    },

    initializeImageSwiper(){
      const vm = this;

      const imageList = [];

      const clickEvent = function(event){
        let target = event.target || event.srcElement;

        let imageIndex   = 0;
        const currentURL = target.getAttribute('src');

        for(let i = 0; i < imageList.length; i++){
          if(imageList[i].src === currentURL){
            imageIndex = i;
            break;
          }
        }

        vm.$store.dispatch({
          type        : 'photoSwipe/updateImages',
          images      : imageList,
          imageIndex  : imageIndex,
        });
      };

      this.$refs.contentField.querySelectorAll('img').forEach((imageObject) => {
        imageList.push({
          src : imageObject.getAttribute('src'),
          w   : 0,
          h   : 0,
        });
      });

      this.$refs.contentField.querySelectorAll('img').forEach((imageObject) => {
        imageObject.removeEventListener('click', clickEvent);
        imageObject.addEventListener('click', clickEvent);
      });
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";

.pa-park-note-detail{
  border-radius: 12px;
  background-color: #CCAA8B;
  background-color: #C8A984;

  .pa-title{
    margin:0 .5rem;
    padding:.5rem 0 .2rem;
    // color:#7C5E49;
    color:#604938;
    border-bottom:1px solid #B0906A;
    font-size:1.15rem;
    line-height: 1.15;
  }

  .pa-date{
    margin:.4em .5rem 0;
    padding:0 .5rem;
    font-size:.6rem;
    text-align: right;
    // color:#B0865E;
    color:#b18c5f;
  }

  .pa-meta{
    margin:.1rem .5rem .4rem;
    padding:.3rem .5rem .3rem;
    // background-color: #CCAD91;
    background-color: #caa67a;
    // color:#B58E6C;
    // color:#B0845D;
    color:#795B46;
    position: relative;

    .date{
      font-size:.6rem;
      text-align: right;
      // position: absolute;
    }

    .character-meta{
      margin-top:.3rem;
      display: flex;
      text-align: right;
      justify-content:flex-end;

      .character-icon{
        .pa-character-icon{
          color:#795B46;
          margin:0;
          width:30px;
          height:30px;
          background-color:#BD9C75;
          font-size:14px;
          line-height:28px;
        }
      }

      .pa-name{
        margin-left:.3rem;
        line-height: 30px;
      }
    }
  }

  .pa-content{
    margin:.3rem .5rem 0;
    padding-bottom: 10px;
    font-size:1rem;
    color:#3e3a37;

    h1{
      margin:.2rem 0;
      font-size:1.5rem;
    }

    strong{
      color:inherit;
    }

    a{
      text-decoration: underline;
    }

    h1, h2, h3, h4, h5, h6, p{
      word-wrap: break-word;
    }
  }

  .pa-footer-meta{
    width:95%;
    margin:0 auto 0;
    padding:.5rem 0 .3rem;
    // border-top: 1px solid #C6A485;
    border-top: 1px solid #c29f75;
    // color:#BB9D79;
    color:#9e8362;
    position: relative;
    min-height:1.5rem;

    .pa-badges{
      position: absolute;
      top:0;
      right:0;
      margin-top: .4rem;
      margin-left: .3rem;
      color:#604938;
      display: flex;

      .pa-heart-plus-button{
        margin-right:.5rem;
      }

      .pa-common-badge-banner{
        margin-right:.5rem;

        &:last-child{
          margin-right:0;
        }
      }
    }

    .pa-controls{
      .control-button{
        margin:0 .5rem 0 0;
        padding:.2rem 1rem;
        line-height: 1rem;
        height:1rem;
        font-size:.75rem;

        border:0;
        background-color: #BB9D79;
        color:#7D593C;
        border-radius: 6px;

        &:last-child{
          margin-right:0;
        }
      }
    }
  }

  .pa-comment-view{
    width:95%;
    margin:0 auto;
    border-top:1px solid #CAA889;
  }
}
</style>